import(
  /* webpackChunkName: "pharmacyBase" */ './pharmacyBase.js'
  ).then(({ pharmacyBase }) => pharmacyBase())

// FOOTER
import(
  /* webpackChunkName: "pharmacySearch" */ './pharmacySearch.js'
  ).then(({ pharmacySearch }) => pharmacySearch())


